<div class="d-flex align-items-center mb-2">
  <div class="symbol symbol-45px w-40px me-5">
    <span class="symbol-label bg-lighten">
      <bws-mdi [name]="icon" class="fs-1"/>
    </span>
  </div>
  <div class="d-flex align-items-center w-100">
    <div class="mb-1 pe-3 flex-grow-1">
      <div class="fs-5 text-gray-800 fw-bold">
        {{left}}
      </div>
      @if (leftSubtitle) {
        <div class="text-muted fw-semibold">
          {{leftSubtitle}}
        </div>
      }
    </div>
    <div class="d-flex align-items-center">
      <div class="fw-bold fs-5 text-gray-800 pe-1">
        {{right}}
      </div>
    </div>
  </div>
</div>
